<template>
  <!-- 添加积分商品 -->
  <div class="addIntGoods">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="100px"
        :rules="addFormRule"
        ref="addForm"
      >
        <div class="form-item-wrap">
          <el-form-item label="商品名称" prop="name">
            <el-input
              v-model="addForm.name"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品规格" prop="specification">
            <el-input
              v-model="addForm.specification"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="商品分类" prop="classify">
          
            <div id="example-5">
             <el-select v-model="addForm.classify" placeholder="请选择"  style="width: 200px">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="展示楼层" prop="floor">
            <div id="example-5">
              <el-select v-model="addForm.floor" placeholder="请选择"  style="width: 200px">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="生产厂家" prop="producer">
            <el-input
              v-model="addForm.producer"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="价格" prop="price">
            <el-input
              v-model="addForm.price"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="积分" prop="creditsExchange">
            <el-input
              v-model="addForm.creditsExchange"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="库存" prop="repertory">
            <el-input
              v-model="addForm.repertory"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="包装单位" prop="creditsExchange">
            <el-input
              v-model="addForm.normal"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传图片" prop="image">
            <img-view :imgList="[{ url: coverImg, id: 0 }]"> </img-view>
            <!-- 文件上传组件 -->
            <upload
              @fileChange="imgFallback"
              accept="image/jpg,image/jpeg,image/png">
            </upload>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button type="info">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项

export default {
  name: "addIntGoods",
  data() {
    return {
      /**新增表单 */
      //商品名称 商品规格 包装单位 商品分类 展示楼层 上传图片 生产厂家 价格 积分 库存
      addForm: {
        name: "",
        specification: "",
        packingNnit: "",
        classify: "",
        floor: "",
        producer: "",
        price: "",
        creditsExchange: "",
        repertory: "",
        normal: "",
      },
      /**新增表单规则 */
      addFormRule: {
        name: [mustFill],
        specification: [mustFill],
        packingNnit: [mustFill],
        classify: [mustFill],
        floor: [mustFill],
        producer: [mustFill],
        price: [mustFill],
        creditsExchange: [mustFill],
        repertory: [mustFill],
        normal: [mustFill],
      },
      coverImg: "",
      options: [
        { text: "热门兑换", value: "热门兑换" },
        { text: "家用电器", value: "家用电器" },
        { text: "移动电器", value: "移动电器" },
        { text: "办公用品", value: "办公用品" },
        { text: "赠品", value: "赠品" },
        { text: "其它", value: "其它" },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    /**图片成功上传回调 */
    imgFallback(file) {
      if (file.length) {
        var msg = new FormData();
        msg.append("file", file[0]);
        this.$uploadRequest({
          url: "Integral/ashx/PictureUpload.ashx",
          data: msg,
          method: "post",
        }).then((res) => {
          console.log(res);
          if (res.return_code == 0) {
            this.coverImg = (res.data && res.data[1] && res.data[1].picture) || this.addForm.img;
            this.$message({
              message: '图片上传成功',
              type: 'success'
            });
          }else{
            this.$message({
              message: (res.data && res.data[0] && res.data[0].message) || '上传失败',
              type: 'error'
            });
          }
        }).catch((err) => {
          window.console.log(err);
        });
      }
    },
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let goodsName = this.addForm.name; //名称
          let goodsSpecifications = this.addForm.specification; //规格
          let unit = this.addForm.normal; //单位
          let classification = this.addForm.classify; //分类
          let floor = this.addForm.floor; //楼层
          let hiddenUrl = this.coverImg; //图片路径
          let vendel = this.addForm.producer; //厂家
          let price = this.addForm.price; //价格
          let integral = this.addForm.creditsExchange; //积分
          let Quantity = this.addForm.repertory; //库存
          let type = "Integral_Goods_Insert";
          let Procedure = "Proc_Integral";

          console.log("Integral/ashx/IntegralGoodsOperation.ashx?GoodsName=" + encodeURI(goodsName) + "&GoodsSpecifications=" + encodeURI(goodsSpecifications) + "&Unit=" + encodeURI(unit) + "&Classification=" + encodeURI(classification) + "&Floor=" + encodeURI(floor) + "&HiddenUrl=" + encodeURI(hiddenUrl) + "&Vendel=" + encodeURI(vendel) + "&Price=" +  encodeURI(price) + "&Integral=" + encodeURI(integral) + "&type=" + encodeURI(type) + "&Procedure=" + encodeURI(Procedure) + "&Quantity=" + encodeURI(Quantity) + "&xentId=" + encodeURI(localStorage.getItem('entId')));
          
          this.$requestSys({
            url: "Integral/ashx/IntegralGoodsOperation.ashx?GoodsName=" + encodeURI(goodsName) + "&GoodsSpecifications=" + encodeURI(goodsSpecifications) + "&Unit=" + encodeURI(unit) + "&Classification=" + encodeURI(classification) + "&Floor=" + encodeURI(floor) + "&HiddenUrl=" + encodeURI(hiddenUrl) + "&Vendel=" + encodeURI(vendel) + "&Price=" +  encodeURI(price) + "&Integral=" + encodeURI(integral) + "&type=" + encodeURI(type) + "&Procedure=" + encodeURI(Procedure) + "&Quantity=" + encodeURI(Quantity) + "&xentId=" + encodeURI(localStorage.getItem('entId')),
            method: "post",
          }).then((res) => {
            window.console.log(res);
          }).catch((err) => {
            window.console.log(err);
          });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.addIntGoods {
  width: 100%;
  height: 100%;
}
.form-item-wrap {
  display: flex;
  padding: 0 0 0 20px;
  box-sizing: border-box;
}
</style>
